/**
 * Get the call's most recent call status
 * @param {Object} props
 * @param {String? | null} props.callerID - caller id in the 911 calls queue
 * @param {Object} props.callQueue - callQueue/emergencyCalls/filteredCalls
 * @param {Boolean} props.hasAniAliAccess - ani/ali capability
 * @param {Boolean} props.hasCallStatusAccess - call status capability
 * @returns String || null
 */
const getMostRecentCallStatus = ({
  callerID,
  callQueue,
  hasAniAliAccess,
  hasCallStatusAccess,
}) => {
  return (
    (hasAniAliAccess &&
      hasCallStatusAccess &&
      callQueue?.[callerID]?.callStatuses?.[
        callQueue?.[callerID]?.callStatuses?.length - 1
      ]) ||
    null
  );
};

export default getMostRecentCallStatus;
